var _effectorFileName = "/builds/gmini/front-ui-kit/src/RadioButton/RadioButton.tsx";
import { RadioInput, Label, Text } from './RadioButton.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RadioButton = ({
  selected,
  label,
  color,
  ...other
}) => /*#__PURE__*/_jsxs(Label, {
  children: [/*#__PURE__*/_jsx(RadioInput, {
    color: color,
    type: "radio",
    selected: selected,
    ...other
  }), label && /*#__PURE__*/_jsx(Text, {
    children: label
  })]
});